import { Loader } from '@devd-client/devd/components';
import React, { Suspense } from 'react';

const ClickupInstallation = React.memo(
  React.lazy(() =>
    import('@devd-client/devd/ui-shared').then((module) => ({
      default: module.ClickupInstallation,
    }))
  )
);

export function AsyncClickupInstallation() {
  return (
    <Suspense fallback={<Loader />}>
      <ClickupInstallation />
    </Suspense>
  );
}
